// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FooterSocial_wrapper__2YaY5","label":"FooterSocial_label__1Tvzq","email":"FooterSocial_email__3fVYA","social":"FooterSocial_social__1ib3M"};